import { Select, SelectProps } from 'components/Select/Select';

import { DATA_POOLS } from 'dashboards/services/data_pool';
import { DataPoolName } from 'dashboards/types/data_pool';

const OPTIONS = Object.entries(DATA_POOLS).map(([key, { label }]) => ({
  label,
  value: key as DataPoolName,
}));

type DataPoolSelectProps = Omit<
  SelectProps<{ label: string; value: DataPoolName }>,
  'value' | 'onChange' | 'defaultValue'
> & {
  value?: DataPoolName;
  defaultValue?: DataPoolName;
  onChange: (value: DataPoolName | null) => void;
};

export function DataPoolSelect({
  value,
  defaultValue,
  onChange,
  ...props
}: DataPoolSelectProps) {
  return (
    <Select
      {...props}
      value={value ? { label: DATA_POOLS[value].label, value } : undefined}
      defaultValue={
        defaultValue
          ? {
              label: DATA_POOLS[defaultValue].label,
              value: defaultValue,
            }
          : undefined
      }
      onChange={(option) => (option ? onChange(option.value) : option)}
      options={OPTIONS}
    />
  );
}
